// Provider e modello in due select affiancate, per le righe strette (team e fasi del piano): la
// stessa cascata di ModelPicker senza cornice. La prima voce del provider segue chi decide sopra
// (il pop, i pops della fase); provider e modelli arrivano dal server.
import { Select } from '../../components/Select';
import type { ConnectedProvider } from '../../lib/api';
import { modelLabel } from './AgentEditor';
import { modelKey } from './ModelPicker';

const UNKNOWN = '__unknown';

export function ModelPair({
  providers,
  value,
  onChange,
  who,
  followsName,
  followsFrom,
}: {
  providers: ConnectedProvider[];
  value: string | null;
  onChange: (model: string | null) => void;
  /** chi usa il modello, per le etichette accessibili («di Dario») */
  who: string;
  /** la prima voce, quando non si sceglie: «Quello del pop» */
  followsName: string;
  /** cosa dice il modello in quel caso: «dal pop» */
  followsFrom: string;
}) {
  const catalog = (p: ConnectedProvider) =>
    p.catalog.length
      ? p.catalog.map((m) => ({
          id: modelKey(p, m),
          label: m.label === m.id ? m.id : `${m.label} · ${m.id}`,
        }))
      : p.models.map((m) => ({ id: modelKey(p, m), label: m }));
  const provider = value
    ? (providers.find((p) => catalog(p).some((m) => m.id === value)) ?? null)
    : null;
  // un modello salvato che nessun provider collegato offre più resta visibile, non si perde
  const lost = !!value && !provider;

  return (
    <div className="model-pair">
      <Select
        label={`Provider ${who}`}
        value={lost ? UNKNOWN : (provider?.id ?? '')}
        onChange={(id) => {
          if (id === UNKNOWN) return;
          const p = providers.find((x) => x.id === id);
          onChange(p ? (catalog(p)[0]?.id ?? null) : null);
        }}
        options={[
          { value: '', label: followsName },
          ...(lost ? [{ value: UNKNOWN, label: 'Non più collegato' }] : []),
          ...providers.map((p) => ({ value: p.id, label: p.name })),
        ]}
        width="100%"
      />
      <Select
        label={`Modello ${who}`}
        value={value ?? ''}
        onChange={(v) => onChange(v || null)}
        options={
          lost
            ? [{ value: value as string, label: modelLabel(value as string) }]
            : provider
              ? catalog(provider).map((m) => ({ value: m.id, label: m.label }))
              : [{ value: '', label: followsFrom }]
        }
        width="100%"
      />
    </div>
  );
}
